import Fondo from "../assets/comentarios.jpg"

const Testimonio = () => {
    return (
        <div
            className="w-full h-screen bg-cover bg-center flex items-center justify-start text-black"
            style={{ backgroundImage: `url(${Fondo})` }}
        >
            <div className="w-full text-white px-4 md:px-20 text-center grid grid-cols-1 gap-4 md:gap-24">
                <div>
                    <h2 className="text-6xl text-red-600 font-bold underline underline-offset-8">Testimonios</h2>
                </div>
                <div className="w-1/2 mx-auto text-black">
                    <p>Lunes 27 de Febrero , 2021</p>
                    <h2 className="text-2xl text-red-500 font-bold">"La confianza que nos ha dado contar con cámaras dentro y fuera de la oficina es algo inigualable"</h2>
                </div>
                <div className="text-black">
                    <p className="text-lg">Elizabeth Vazquez</p>
                    <p className="text-lg">Gerente, San Martín, Pue.</p>
                </div>
            </div>
        </div>
    );
};

export default Testimonio;